import React from 'react'
import { FormattedMessage } from 'react-intl'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import { Breadcrumbs, Breadcrumb, BreadcrumbLink } from 'legacy/components/Breadcrumbs'
import AisleBreadcrumbLink from './AisleBreadcrumbLink'
import DepartmentBreadcrumbLink from './DepartmentBreadcrumbLink'
import withRetailerRouter from 'legacy/common/withRouter'
import { type ProductFormValues } from 'legacy/routes/catalog/types/product.types'

interface Props extends RetailerRouteComponentProps {
  productData: ProductFormValues | null
}

const EditProductBreadcrumbs = ({ url, productData }: Props) => (
  <Breadcrumbs>
    <BreadcrumbLink to={url('new-search')}>
      <FormattedMessage id="catalog.search" />
    </BreadcrumbLink>
    <DepartmentBreadcrumbLink url={url} />
    <AisleBreadcrumbLink url={url} />
    <Breadcrumb>
      <FormattedMessage id="catalog.product.edit.title" />
    </Breadcrumb>

    {productData && (
      <Breadcrumb>
        {productData.brand_name} {productData.name}
      </Breadcrumb>
    )}
  </Breadcrumbs>
)

export default withRetailerRouter(EditProductBreadcrumbs)
